import lodash from 'lodash'

export default ({ Vue }) => {
  Vue.use(lodash)
  Vue.prototype._ = lodash
}
